module.exports = __webpack_public_path__ + "static/bg-subpage-header-9967212c76a49a3866c0085981b7f0ce.png";